//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgClose } from '../icons/Close';

export function CloseIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgClose} data-qa="CloseIcon">
      <svg />
    </SvgIcon>
  );
}
